<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{name: 'AccountExports'}" class="subtitle-1 routerLink font-weight-medium">Exportar</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>Suscripciones
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 pb-0 background">
          <v-row class="px-4">
            <v-col cols="12" sm="10" md="9">
              <span class="body-2 text--secondary font-weight-medium">Filtrar registros</span>
              <v-query-builder :flat="true" :query-map="rules" filter-text="Previsualizar" model="subscription" />
            </v-col>
          </v-row>
          <v-row class="px-4">
            <v-col>
              <span class="body-2 text--secondary font-weight-medium">Previsualización</span>
            </v-col>
          </v-row>
          <v-divider />
          <subscription-list :show-pagination="false" />
          <v-divider />
          <v-row class="px-4">
            <v-col>
              <span class="body-2 text--secondary font-weight-medium">{{count}} registros</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="createExport" :loading="$store.state.accounts.createLoader" color="primary">Exportar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import SubscriptionList from '@/components/subscription/SubscriptionList'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VQueryBuilder,
    SubscriptionList
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    isPreview: false,
    rules: [
      {
        type: 'text',
        id: 'customer__name',
        label: 'Cliente',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'lines__plan__name',
        label: 'Plan',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'addons__addon__name',
        label: 'Complemento',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'coupon__name',
        label: 'Cupón',
        operators: ['contiene']
      },
      {
        type: 'numeric',
        id: 'lines__plan__amount',
        label: 'Precio del plan',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'select',
        id: 'status',
        label: 'Status',
        choices: [
          { value: 'active', label: 'Activo' },
          { value: 'paused', label: 'Pausado' },
          { value: 'cancelled', label: 'Cancelado' },
          { value: 'finalized', label: 'Finalizado' }
        ]
      },
      {
        type: 'select',
        id: 'cancel_reason',
        label: 'Razón de la cancelación',
        choices: [
          // TODO reutilize this object
          { value: 'not_paid', label: 'Sin pago' },
          { value: 'no_card', label: 'Sin tarjeta de crédito o débito' },
          { value: 'fraud_review_failed', label: 'Revisión de fraude fallida' },
          { value: 'non_compliant_customer', label: 'Cliente no conforme' },
          { value: 'not_specified', label: 'No especificado' }
        ]
      },
      {
        type: 'text',
        id: 'date_start',
        label: 'Fecha de inicio',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'text',
        id: 'next_billing',
        label: 'Próxima facturación',
        operators: ['es igual', 'es menor a', 'es mayor a']
      }
    ]
  }),
  computed: mapState({
    list: state => state.subscriptions.SubscriptionList,
    count: state => state.subscriptions.subscriptionsCount
  }),
  methods: {
    getList () {
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'subscriptions',
        query: Object.assign({}, this.$route.query, { page_size: 10 })
      })
    },
    str2bytes (str) {
      var bytes = new Uint8Array(str.length)
      for (var i = 0; i < str.length; i++) {
        bytes[i] = str.charCodeAt(i)
      }
      return bytes
    },
    createExport () {
      this.$store.dispatch('accounts/LIST', {
        resource: 'exports/subscriptions',
        query: this.$route.query,
        loader: true,
        responseType: 'arraybuffer'
      })
      .then(async (response) => {
        let blob = await new Blob([response.data], {type: "application/zip"})
        saveAs(blob, 'subscriptions.zip')
        this.$dialog.message.info('La exportación se realizó con éxito')
      })
      .catch(() => {
        this.$dialog.message.error('Ha ocurrido un error en la exportación')
      })
    }
  }
}
</script>